import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    padding: "16px 18px",
    minWidth: 0,
  },
  label: { fontSize: 12, fontWeight: 600, letterSpacing: 0.4, textTransform: "uppercase", color: theme.palette.text.secondary },
  value: { fontSize: 30, fontWeight: 700, color: theme.palette.text.primary, marginTop: 6, lineHeight: 1.1 },
  hint: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 4 },
  live: { display: "inline-block", width: 8, height: 8, borderRadius: 4, backgroundColor: "#16A34A", marginRight: 6 },
}));

/** Tarjeta de cifra de los Informes (doc 0447). `live`: punto verde = foto de «ahora». */
const KpiCard = ({ label, value, hint, live }) => {
  const classes = useStyles();
  return (
    <div className={classes.card}>
      <div className={classes.label}>
        {live && <span className={classes.live} aria-hidden="true" />}
        {label}
      </div>
      <div className={classes.value}>{value}</div>
      {hint && <div className={classes.hint}>{hint}</div>}
    </div>
  );
};

export default KpiCard;
